<template>
  <q-layout id="subscriptions-view bg-pl-gray-50" view="lhh lpR lfr">
        <TopNav id="top-nav"></TopNav>
        <LeftDrawer id="side-nav"></LeftDrawer>
        <AsyncContent id="view-content"></AsyncContent>
    </q-layout>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AsyncContent from '@/components/AsyncContent.vue';
import TopNav from '@/components/TopNav.vue';
import LeftDrawer from '@/components/LeftDrawer.vue';
import { provideStore as provideSubscriptionsStore } from '@/store/subscriptions/subscriptions';

export default defineComponent({
  name: 'Subscriptions',
  components: {
    AsyncContent,
    TopNav,
    LeftDrawer
  },
  setup () {
    provideSubscriptionsStore();
  }
});
</script>
